export default "__VITE_ASSET__$Go_wcaX__"